import React from 'react'
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CautionImg from '../assets/caution_img.svg'
import { CAR_ARRIVED, CAR_HANDOVER } from '../utils/shareData';

const PaymentInfo = ({ currentActivity, bookingDetails, isLinkWithVisitor }) => {
    const theme = useTheme();

    const Info = () => {
        return (
            <Box sx={{ marginBottom: "15px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: "#F0FEEF", width: "100%", padding: "8px 8px", borderRadius: "4px" }}>
                {!isLinkWithVisitor &&
                    <>
                        <Box sx={{ color: "#3D3D3d", fontSize: "14px", marginBottom: "5px", fontWeight: theme.typography.fontWeightMedium }}>Total Amount</Box>
                        <Box sx={{ color: "#18CC69", fontSize: "24px", fontWeight: theme.typography.fontWeightSemibold }}>₹ {bookingDetails.amount}</Box>
                        <Box sx={{ backgroundColor: "#DCDCDC", width: "100%", height: "1px", marginTop: "8px", marginBottom: "8px" }}></Box>
                    </>
                }
                <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                    <img src={CautionImg} alt='Caution' width={20} height={20} />
                    <Box sx={{ color: "#03301A", fontSize: "14px", marginLeft: "10px", fontWeight: theme.typography.fontWeightMedium }}>Please pay the amount at the Exit.</Box>
                </Box>
            </Box>
        )
    }

    if (currentActivity.name === CAR_ARRIVED) return Info()
    else if (currentActivity.name === CAR_HANDOVER && isLinkWithVisitor) return Info()
    else return null
}

export default PaymentInfo